import { useRecoilState } from 'recoil';
import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { selectedPage as selectedPageAtom } from '../../atoms/PageState';
import { permissions as permissionsAtom } from '../../atoms/Users';
import { getUserPermissions } from '../../variables/Users';
import { getPagesListByPermission } from '../../variables/Pages';
import { PageType } from '../../interfaces/Page';
import NotFound from '../NotFound';
import ExperimentUI from './ExperimentUI';
import ExperimentDetail from './ExperimentDetail';
import ExperimentEdit from './ExperimentEdit';
import ExperimentAnalysis from './ExperimentAnalysis';

const ExperimentUIPageRoot = () => {
  const [permissions, setPermissions] = useRecoilState(permissionsAtom);
  const [selectedPage, setSelectedPage] = useRecoilState(selectedPageAtom);

  useEffect(() => {
    setPermissions(getUserPermissions());
  }, []);

  useEffect(() => {
    const pages = getPagesListByPermission(permissions);
    let index = -1;
    for (let i = 0; i < pages.length; i += 1) {
      if (pages[i].pageType === PageType.EXPERIMENTS_UI) {
        index = i;
        break;
      }
    }

    if (selectedPage !== index) {
      setSelectedPage(index);
    }
  }, [permissions]);

  return (
    <Routes>
      <Route path={'/'} element={<ExperimentUI />}></Route>
      <Route path={'/:id'} element={<ExperimentDetail />}></Route>
      <Route path={'/:id/edit'} element={<ExperimentEdit />}></Route>
      <Route path={'/analysis'} element={<ExperimentAnalysis />}></Route>
      <Route path='*' element={<NotFound />}></Route>
    </Routes>
  );
};

export default ExperimentUIPageRoot;
